export default {
  common: {
    bingWallpaper: '必应壁纸',
    home: '首页',
    about: '关于',
    blog: '博客',
    refresh: '刷新页面',
    loading: '加载中...',
    year: '年',
    preview: '预览',
    close: '关闭',
    today: '今天',
    yesterday: '昨天',
    dayBefore: '前天',
    daysAgo: '天前',
    monthsAgo: '个月前',
    yearsAgo: '年前',
    unknown: '未知',
    copySuccess: '已复制到剪贴板',
    copyFail: '复制失败，请手动复制',
    language: '语言',
    chinese: '中文',
    english: 'English',
    visitorCount: '您是本站第 {count} 个小伙伴',
    copyright: '本站所有图片均来自必应搜索，仅供学习和个人使用',
    footerCopyright: 'Copyright © 2022 - {year}',
    openMenu: '打开菜单',
    fatalError: '页面加载出现问题，请刷新重试',
    regionChina: '中国',
    regionGermany: '德国',
    regionCanada: '加拿大',
    regionUK: '英国',
    regionIndia: '印度',
    regionUS: '美国',
    regionFrance: '法国',
    regionItaly: '意大利',
    regionJapan: '日本',
    netdiskQuark: '夸克网盘',
    netdiskAlipan: '阿里网盘',
    downloadViaNetdisk: '下载高清壁纸',
    use: '使用'
  },
  wallpaper: {
    siteTitle: '必应壁纸 - 微软必应每日高清壁纸下载',
    siteDesc: '必应壁纸(Bing Wallpaper)下载站，每天同步更新{strong}微软必应{/strong}官方每日壁纸，提供{strong}中国、美国、日本、德国、英国、法国、意大利、加拿大、印度{/strong}等9个国家地区的必应壁纸浏览与下载。支持 {strong}4K、1920×1080、1920×1200、1366×768{/strong} 等多种分辨率切换，可按年份筛选并{strong}一键批量下载{/strong}全年壁纸打包，所有高清壁纸免费下载，适合作为电脑桌面和手机壁纸使用。',
    regionFilter: '地区筛选',
    resolutionFilter: '图片尺寸',
    yearFilter: '年份筛选',
    selectRegion: '选择地区',
    selectResolution: '选择尺寸',
    selectYear: '选择年份',
    yearHint: '选择年份后批量下载可直接下载整个年份',
    currentFilter: '当前筛选',
    totalWallpapers: '共 {count} 张壁纸',
    batchDownload: '批量下载',
    downloadingWallpapers: '正在下载壁纸...',
    packaging: '正在打包...',
    downloadSuccess: '成功下载 {count} 张壁纸',
    downloadFailed: '批量下载失败，请重试',
    noWallpapers: '没有可下载的壁纸',
    noResults: '没有找到符合条件的壁纸',
    clearFilters: '清除筛选条件',
    filterRegion: '地区',
    filterYear: '年份',
    filterResolution: '尺寸',
    fetchFailed: '获取壁纸数据失败',
    fetchFailedNetwork: '获取壁纸数据失败，请检查网络连接',
    unknownError: '未知错误',
    yearSuffix: '年'
  },
  detail: {
    viewOriginal: '查看原图',
    backHome: '返回首页',
    downloadWallpaper: '下载壁纸',
    copyLink: '复制链接',
    viewFullscreen: '查看全屏壁纸',
    fullscreenTooltip: '点击壁纸图片即可全屏查看',
    imageDescription: '图片介绍',
    viewSource: '查看来源',
    openOriginal: '打开原图',
    copyrightInfo: '版权信息',
    publishDate: '发布日期',
    switchResolution: '切换分辨率',
    recommended: '推荐壁纸',
    loadingDetail: '正在加载壁纸详情...',
    loadFailed: '加载失败',
    reload: '重新加载',
    loadingImage: '正在加载图片...',
    imageLoadFailed: '图片加载失败',
    missingId: '缺少壁纸ID参数',
    notFound: '未找到该壁纸',
    fetchDetailFailed: '获取壁纸详情失败',
    networkError: '网络连接异常，请检查网络后重试',
    resolutionSwitched: '分辨率已切换为 {resolution}',
    startDownload: '开始下载壁纸',
    linkCopied: '图片链接已复制到剪贴板',
    setDesktopHint: '右键点击图片选择"设置为桌面背景"即可',
    alreadyFavorited: '该壁纸已收藏过',
    favoriteSuccess: '壁纸收藏成功',
    copyFailedManual: '复制失败，请手动复制',
    wechatShareHint: '请使用微信扫码分享',
    shareLinkCopied: '分享链接已复制',
    sharePrefix: '必应壁纸：'
  },
  about: {
    title: '关于必应壁纸',
    subtitle: '一个精美的必应壁纸展示站点，提供丰富的壁纸浏览、筛选和下载功能。',
    timeline1Title: '完善各个页面',
    timeline2Title: '第一个版本，完成基本布局',
    timeline3Title: '修复分页器无法正常显示的bug',
    timeline4Title: '全新改版',
    timeline4Item1: '1、完善列表样式布局，使其更美观，操作更简单',
    timeline4Item2: '2、修复分页器的bug（不再依靠bug运行啦！！！）',
    timeline4Item3: '3、支持多维度筛选壁纸，如：地区、分辨率、年份等',
    timeline4Item4: '4、支持一键下载筛选年份的所有壁纸并打包',
    frontendProject: '前端项目地址：',
    backendProject: '后端项目地址：',
    backendTutorial: '后端教程：',
    selfBuildApi: '自搭建必应api',
    postPara1: '后端搭建使用了文档数据库{link}Mongodb{/link}作为数据存储，使用了无限量构建的CI/CD持续集成工具{link2}Github Action{/link2}获取每日壁纸数据并存储到Mongodb，使用了Python高性能异步{link3}FastApi{/link3}作为后端框架，使用了{link4}Vercel{/link4}承载用户的请求实现serverless。前端搭建使用了{link5}ElementUI{/link5}框架速开',
    postPara2: '刚开始接触必应壁纸时只是在必应上看到了许多优秀的壁纸，想要个api当作博客的背景图片使用，后面自己也学着搭建了一个api。一路上磕磕绊绊，后端api学到了许多知识，比如Python第三方库pymongo的简单使用，FastAPI的搭建，Python的模块化设计；前端学到了导航栏的布局，三方图标库的导入，vue-router的使用，axios封装的请求库，分页器的加载。',
    postPara3: '期间也遇到了许多困难，后端翻了很多资料才知道必应壁纸api可以分地区，但是国区还被强制重定向了，vercel搞了好久也解决不了后端和前端同时放在一起的请求方式，FastAPI也走了许多小坑，查了好久的资料加上模仿大佬的设计才完成Python的模块化设计。前端{link}ElementUI{/link}翻了N遍，bug还出现了一堆，vue-router学着官网的的例子才懂，分页器还有一个bug没解决，PS：这个bug还不能去掉，项目依靠这个bug运行。',
    postPara4: '{strong}AI{/strong}真是太好用了！！！',
    postPara5: '现在，bing-wallpaper开通{link}Twikoo{/link}评论系统，大家有问题可以在此留言'
  },
  seo: {
    siteName: '必应壁纸',
    defaultTitle: '必应壁纸 | 每天都有不一样的心情 | 各国必应壁纸下载',
    defaultDescription: '必应壁纸(Bing Wallpaper)下载站，提供微软必应每日高清壁纸，支持多地区、多分辨率浏览与下载。',
    homeTitle: '必应壁纸 | 每天都有不一样的心情 | 各国必应壁纸下载',
    homeDescription: '必应壁纸(Bing Wallpaper)下载站，提供微软必应每日高清壁纸，支持中国、美国、日本、德国、英国、法国等9个国家地区的必应壁纸浏览与下载，提供4K、1920x1080等多种分辨率，一键批量下载全年壁纸。',
    regionTitle: '地区必应壁纸',
    regionDescription: '各地区必应每日高清壁纸下载，支持中国、美国、日本、德国、英国、法国、意大利、加拿大、印度等地区。',
    aboutTitle: '关于我们',
    aboutDescription: '必应壁纸站点介绍，提供微软必应每日高清壁纸下载，支持多地区、多分辨率浏览与下载。本站所有图片均来自必应搜索，仅供学习和个人使用。',
    detailTitle: '壁纸详情',
    detailDescription: '必应壁纸详情页，查看高清壁纸并支持多种分辨率下载。',
    regionSeoTitle: '{name}必应壁纸 - {name}地区每日高清壁纸下载',
    regionSeoDesc: '{name}必应壁纸下载，提供微软必应{name}地区每日高清壁纸，支持4K、1920x1080等多种分辨率，免费下载高清电脑壁纸。',
    regionSeoKeywords: '{name}必应壁纸,{name}壁纸,必应壁纸,高清壁纸下载',
    detailSeoTitle: '{title} - {region}必应壁纸高清下载',
    detailSeoDesc: '{title}。{copyright} 发布于{date}{region}。必应壁纸提供4K、1920x1080等多种分辨率免费下载。',
    detailSeoKeywords: '{title},{region}必应壁纸,高清壁纸下载,bing wallpaper,{date}',
    detailSeoKeywordsNoRegion: '{title},必应壁纸,高清壁纸下载,bing wallpaper,{date}',
    detailSeoTitleNoRegion: '{title} - 必应壁纸高清下载',
    detailSeoFromRegion: '，来自{name}地区',
    siteJsonLdDesc: '必应壁纸下载站，提供微软必应每日高清壁纸，支持多地区、多分辨率浏览与下载。',
    regionJsonLdDesc: '{name}地区的必应每日高清壁纸下载，支持4K、1920x1080等多种分辨率。',
    breadcrumbHome: '首页',
    breadcrumbRegion: '{name}必应壁纸',
    defaultKeywords: '必应壁纸,bing壁纸,必应每日壁纸,必应高清壁纸下载,微软Bing壁纸,Bing Wallpaper,高清壁纸,电脑壁纸,4K壁纸,壁纸下载',
    htmlTitle: '必应壁纸 | 每天都有不一样的心情 | 各国必应壁纸下载',
    htmlDescription: '必应壁纸(Bing Wallpaper)下载站，提供微软必应每日高清壁纸，支持中国、美国、日本、德国、英国、法国等9个国家地区的必应壁纸浏览与下载，提供4K、1920x1080等多种分辨率，一键批量下载全年壁纸。',
    htmlKeywords: '必应壁纸,bing壁纸,必应每日壁纸,必应高清壁纸下载,微软Bing壁纸,Bing Wallpaper,高清壁纸,电脑壁纸,4K壁纸,壁纸下载,各国必应壁纸,中国必应壁纸,美国必应壁纸,日本必应壁纸,德国必应壁纸,英国必应壁纸,法国必应壁纸,意大利必应壁纸,加拿大必应壁纸,印度必应壁纸,必应壁纸API,必应壁纸合集,每日壁纸',
    htmlH1: '必应壁纸 - 微软必应每日高清壁纸下载',
    htmlP: '必应壁纸(Bing Wallpaper)下载站，提供微软必应每日高清壁纸，支持中国、美国、日本、德国、英国、法国等9个国家地区的高清壁纸浏览与下载，支持4K、1920×1080等多种分辨率，可一键批量下载全年壁纸。',
    twitterTitle: '必应壁纸 | 每天都有不一样的心情',
    twitterDesc: '微软必应每日高清壁纸下载，支持多地区、多分辨率。'
  }
}



// WEBPACK FOOTER //
// ./src/locale/zh-CN.js